<template>
    <div v-if="showHighlightsAndNotes" dusk="ReaderNoteAndHighlight" class="flex flex-1 flex-col overflow-hidden">
        <ExportNotesOrHighlight
            :disable-export="true"
            :checked-colors="checkedColors"
            @checked-colors="colors => (checkedColors = colors)"
        />
        <div class="flex-1 overflow-y-auto overflow-x-hidden">
            <div
                v-if="highlightsAndNotesListIsEmpty"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noHighlightsAndNotes }}
                </p>
            </div>
            <div
                v-else-if="highlightsAndNotesList.length === 0"
                role="status"
                aria-live="polite"
                class="flex h-full w-full items-center justify-center px-4 text-center text-theme-text"
            >
                <p class="text-sm opacity-60">
                    {{ localizations[lang].noFilterHighlightsAndNotesColor }}
                </p>
            </div>
            <template v-else>
                <SectionLabel>
                    {{ highlightsCount }} {{ localizations[lang].highlights }} · {{ notesCount }}
                    {{ localizations[lang].notes }}
                </SectionLabel>
                <HighlightAndNotesText :highlights="highlightsAndNotesList" />
            </template>
        </div>
    </div>
</template>

<script>
'use strict';

import { mapGetters, mapState } from 'vuex';
import HighlightAndNotesText from '../partials/HighlightAndNotesText.vue';
import ExportNotesOrHighlight from '../partials/ExportNotesOrHighlight.vue';
import SectionLabel from '../partials/SectionLabel.vue';
import checkedColorsMixin from '_shared_/js/mixins/checkedColorsMixin';

export default {
    components: {
        HighlightAndNotesText,
        ExportNotesOrHighlight,
        SectionLabel,
    },
    mixins: [checkedColorsMixin],
    computed: {
        ...mapState(['ui', 'localizations', 'lang', 'selections', 'sharedColors']),
        ...mapGetters(['showHighlightsAndNotes', 'allHighlighters']),

        highlightsAndNotesList() {
            return this.selections.filter(selection => {
                return this.checkedColors.includes(selection.colorSlug);
            });
        },

        highlightsCount() {
            return this.highlightsAndNotesList.filter(selection => !selection.hasAnnotation).length;
        },

        notesCount() {
            return this.highlightsAndNotesList.filter(selection => selection.hasAnnotation).length;
        },

        highlightsAndNotesListIsEmpty() {
            return this.selections.length === 0;
        },
    },
};
</script>
